import listService from '@/services/list'

export const fetchList = ({ commit }, listName) => {
    listService.getList(listName).then(items => {
        commit('SET_LIST', { listName, items })
    })
}

export const fetchLists = ({ commit }, listNames) => {
    for (var listName of listNames) {
        fetchList({ commit }, listName);
    }
}

export const setCluster = ({ commit }, cluster) => {
    commit('SET_CLUSTER', cluster)
}

export const setUUID = ({ commit }, uuid) => {
    commit('SET_UUID', uuid)
}

export const setConfig = ({ commit }, config) => {
    commit('SET_CONFIG', config)
}

export const setValidation = ({ commit }, validation) => {
    commit('SET_VALIDATION', validation)
}
